var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X (Twitter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M0.974885 0.0209961L10.4706 11.0521L0.915039 20.021H3.06578L11.4318 12.1685L18.1911 20.021H25.5096L15.4795 8.36948L24.3738 0.0209961H22.2231L14.5186 7.25281L8.29342 0.0209961H0.974885ZM4.13764 1.39729H7.49974L22.3465 18.6447H18.9844L4.13764 1.39729Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.b2d98efb.svg";
export { ForwardRef as ReactComponent };